import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { IconFunctionalWarningSign24 } from '../Icons';
import * as s from './SidebarTips.css';

/**
 * Карточка "Указывайте источник" в сайдбаре
 */
export const SidebarIndicateTheSourceTip = () => {
  return (
    <SidebarTip
      title={
        <div className={s['title-with-icon-wrapper']}>
          <IconFunctionalWarningSign24 />
          Указывайте источник
        </div>
      }
      theme={'gray'}
    >
      <div className={s['items-wrapper']}>
        <UIText1>
          Материалы частично или полностью скопированные с других источников, должны содержать ссылку на источник.
        </UIText1>

        <UIText1>
          В случае нарушения авторских прав третьих лиц вы можете быть привлечены к ответственности по&nbsp;ст.&nbsp;146
          УК России
        </UIText1>
      </div>
    </SidebarTip>
  );
};
